import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../redux/slices/apiSlice";
import { useDispatch } from "react-redux";

const useAuth = () => {
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const isCalling = useRef(false);

  const [isLoggedin, setIsLoggedIn] = useState(() => {
    return sessionStorage.getItem("isLoggedIn") === "true";
  });
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const hash = window.location.hash ? window.location.hash.substring(1) : "";

  useEffect(() => {
    hash && sessionStorage.setItem("hash", hash);
    const urlParams = new URLSearchParams(hash);
    const idToken = urlParams.get("id_token");
    const accessToken = urlParams.get("access_token");
    accessToken && sessionStorage.setItem("accessToken", accessToken);
    const refreshToken = urlParams.get("refresh_token");
    refreshToken && sessionStorage.setItem("refreshToken", refreshToken);
    const parseToken = (token) => {
      try {
        const base64Url = token.split(".")[1];
        const decodedData = JSON.parse(atob(base64Url));
        decodedData &&
          sessionStorage.setItem("decodedData", JSON.stringify(decodedData));
        return decodedData;
      } catch (err) {
        console.error("Failed to parse token:", err);
        return null;
      }
    };

    const fetchUser = async (decodedToken, idToken) => {
      try {
        setLoading(true);
        if (
          isCalling.current ||
          sessionStorage.getItem("registering") === "true"
        ) {
          return;
        }
        isCalling.current = true;
        sessionStorage.setItem("registering", "true"); // temporary lock
        if (!sessionStorage.getItem("user")) {
          isCalling.current = true;
          let userRole;
          let clients;
          try {
            userRole = JSON.parse(decodedToken["custom:userRole"]);
            clients = JSON.parse(decodedToken["custom:clients"] || "[]");
          } catch (e) {
            userRole = "";
            clients = [];
            userRole = decodedToken["custom:userRole"];
          }
          if (userRole == "agency_user" && clients?.length) {
            let roleObj = clients[0].services.find(
              (obj) => obj.value.toLowerCase() == "bam"
            );
            roleObj?.role?.toLowerCase() == "admin" &&
              (userRole = "agency_admin");
          }
          const payload = {
            user_name: decodedToken["cognito:username"],
            email: decodedToken["email"],
            role: userRole,
            user_id: Date.now(),
            name:  decodedToken["name"],
            client: new URLSearchParams(hash).get("client")
          };
          const result = await dispatch(registerUser({ payload, idToken }));
          if (result?.payload?.data) {
            sessionStorage.setItem(
              "user",
              JSON.stringify(result?.payload?.data)
            );
            setUser(result?.payload?.data);
            setIsLoggedIn(true);
            sessionStorage.setItem("token", idToken);
            sessionStorage.setItem("isLoggedIn", "true");
            isCalling.current = false;
            sessionStorage.removeItem("registering");
            navigate("/creative_approval");
          }else {
            setIsLoggedIn(false);
            sessionStorage.clear();
            isCalling.current = false;
            navigate("/not-found");
          }
        } else {
          setIsLoggedIn(true);
          sessionStorage.setItem("token", idToken);
          sessionStorage.setItem("isLoggedIn", "true");
          navigate("/creative_approval");
        }
      } catch (err) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    if (!user || !isLoggedin) {
      if (idToken) {
        const decodedToken = parseToken(idToken);

        if (decodedToken) {
          const clients = JSON.parse(decodedToken["custom:clients"] || "[]");

          const hasBAMPermission = clients.some((client) =>
            client.services?.some(
              (service) =>
                service.label?.toLowerCase() === "bam" && service.active
            )
          );

          if (hasBAMPermission || ["superadmin"].includes(decodedToken["custom:userRole"].toLowerCase())) {
            fetchUser(decodedToken, idToken);
          } else {
            alert("You do not have permission to access BAM module.");
            navigate("/unauthorized");
          }
        } else {
          navigate("/unauthorized");
        }
      }
      setLoading(false);
    } else {
      const hasRedirected = sessionStorage.getItem("hasRedirected");
      if (!hasRedirected) {
        navigate("/creative_approval");
        sessionStorage.setItem("hasRedirected", "true");
      }
      setLoading(false);
    }
  }, [hash, user, isLoggedin]);

  return { user, isLoggedin, loading };
};

export default useAuth;
